import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XIcon } from '@repo/icons';
import { formatLabel } from '@repo/locale-client';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLabels } from '../../labels';
export default function PhotoZoomOverlay({ image, index, onClose, testId }) {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);
    const handleBackdropClick = () => {
        onClose();
    };
    const handleImageClick = (event) => {
        event.stopPropagation();
    };
    const handleCloseClick = (event) => {
        event.stopPropagation();
        onClose();
    };
    return createPortal(_jsxs("div", { role: "dialog", "aria-modal": "true", "aria-label": formatLabel(getLabels().photo.alt, { index: index + 1 }), className: "z-takeover fixed inset-0 flex items-center justify-center bg-black/80 backdrop-blur-sm", onClick: handleBackdropClick, "data-testid": testId, children: [_jsx("button", { type: "button", onClick: handleCloseClick, className: "bg-primary/30 absolute top-4 right-4 flex size-12 cursor-pointer items-center justify-center rounded-full text-white", "aria-label": getLabels().photo.gallery.zoom.close, "data-testid": testId.append('closeButton'), children: _jsx(XIcon, { size: 24 }) }), _jsx("img", { src: image.large, alt: formatLabel(getLabels().photo.alt, { index: index + 1 }), className: "max-h-[90vh] max-w-[90vw] object-contain", onClick: handleImageClick, "data-testid": testId.append('image') })] }), document.body);
}
